import React, { Component } from "react";
import {
  Button,
  Card,
  Col,
  Container,
  Label,
  Modal,
  Row,
  CardBody,
  ModalHeader,
  ModalBody,
  Spinner,
} from "reactstrap";
import MetaTags from "react-meta-tags";
import API from "../../helpers/api_helper";
import * as Yup from "yup";
import toastr from "toastr";
import moment from "moment-jalaali";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

import paginationFactory, {
  PaginationProvider,
  PaginationListStandalone,
} from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";

import { Formik, Field, Form, ErrorMessage } from "formik";
import BootstrapTable from "react-bootstrap-table-next";
import { Constants } from "helpers/constants";
import { Link } from "react-router-dom";
import DeleteModal from "components/Common/DeleteModal";
import DatePicker from "react-modern-calendar-datepicker";

class Users extends Component {
  constructor(props) {
    super(props);
    this.state = {
      users: [],
      loading: true,
      subLoading: false,
      modal: false,
      formValue: {
        name: "",
        mobile: "",
        type: "admin",
      },
      isEdit: false,
      selectedUser: null,
      deleteModal: false,
    };
  }
  componentDidMount() {
    this.didMount();
  }

  didMount = async () => {
    this.setState({ loading: true });
    try {
      const res = await API.user.list();
      console.log("RES IS : ", res);
      if (res.status) {
        this.setState({
          loading: false,
          users: res.data,
        });
      } else {
        throw res;
      }
    } catch (error) {
      console.log("ERROR CODE 3 : ", error);
    }
  };

  toggle = () => {
    if (this.state.modal) this.setState({ isEdit: false });

    this.setState(prevState => ({
      modal: !prevState.modal,
    }));
  };

  handleSubmitAddForm = async values => {
    const { selectedUser, isEdit } = this.state;
    console.log("VALUES : ", values);
    console.log("IS EDIT : ", isEdit);
    this.setState({ subLoading: true });
    if (isEdit) {
      try {
        const res = await API.user.edit({
          ...values,
          user_id: selectedUser.id,
        });
        if (res.status) {
          toastr.success("کاربر با موفقیت ویرایش شد", "موفق");
          this.setState({
            subLoading: false,
            modal: false,
            isEdit: false,
            selectedUser: null,
          });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        this.setState({ subLoading: false });
        console.log("ERROR CODE 5 : ", error);
      }
    } else {
      console.log("IS NEW FIRE");
      try {
        const res = await API.user.add(values);
        console.log("RES IS : ", res);
        if (res.status) {
          toastr.success("کاربر با موفقیت اضافه شد", "موفق");
          this.setState({ subLoading: false, modal: false });
          this.didMount();
        } else {
          throw res;
        }
      } catch (error) {
        this.setState({ subLoading: false });
        console.log("ERROR CODE 4 : ", error);
      }
    }
  };

  handleUserClick = arg => {
    const { name, mobile, type } = arg;
    console.log("ARG : ", arg);

    this.setState({
      formValue: {
        name,
        mobile,
        type,
      },
      isEdit: true,
      selectedUser: arg,
    });

    this.toggle();
  };

  handleDeleteUser = async () => {
    const { selectedUser } = this.state;
    console.log("SELECTED : ", selectedUser);
    try {
      const { status } = await API.user.delete(selectedUser.id);
      if (status) {
        toastr.success("کاربر با موفقیت حذف شد", "موفق");
        this.setState({ selectedUser: null, deleteModal: false });
        this.didMount();
      } else {
        throw status;
      }
    } catch (error) {
      console.log("ERROR CODE 128 : ", error);
    }
  };

  handleOpenDeleteModal = user => {
    this.setState({ deleteModal: true, selectedUser: user });
  };

  render() {
    const { SearchBar } = Search;
    const {
      users,
      loading,
      modal,
      isEdit,
      subLoading,
      formValue,
      deleteModal,
    } = this.state;

    const pageOptions = {
      sizePerPage: 10,
      totalSize: users.length, // replace later with size(users),
      custom: true,
    };

    const defaultSorted = [
      {
        dataField: "id", // if dataField is not match to any column you defined, it will be ignored.
        order: "desc", // desc or asc
      },
    ];

    const selectRow = {
      mode: "checkbox",
    };

    const columns = [
      {
        text: "id",
        dataField: "id",
        sort: true,
        hidden: true,
        formatter: (cellContent, user) => <>{user.id}</>,
      },
      {
        dataField: "avatar",
        text: "#",
        formatter: (cellContent, user) => (
          <>
            {!user.avatar || user.avatar === "0" ? (
              <div className="avatar-xs">
                <span className="avatar-title rounded-circle">
                  {user.name.charAt(0).toUpperCase()}
                </span>
              </div>
            ) : (
              <div>
                <img
                  className="rounded-circle avatar-xs"
                  src={Constants.imageUrl + user.avatar}
                  alt=""
                />
              </div>
            )}
          </>
        ),
      },
      {
        text: "Name",
        dataField: "name",
        sort: true,
        formatter: (cellContent, user) => (
          <>
            <h5 className="font-size-14 mb-1">
              <Link to="#" className="text-dark">
                {user.name}
              </Link>
            </h5>
            <p className="text-muted mb-0">{user.designation}</p>
          </>
        ),
      },
      {
        dataField: "mobile",
        text: "مبایل",
        sort: true,
      },
      {
        dataField: "type",
        text: "نوع کاربری",
        sort: true,
      },
      {
        dataField: "menu",
        isDummyField: true,
        editable: false,
        text: "Action",
        formatter: (cellContent, user) => (
          <div className="d-flex gap-3">
            <Link className="text-success" to="#">
              <i
                className="mdi mdi-pencil font-size-18"
                id="edittooltip"
                onClick={() => this.handleUserClick(user)}
              ></i>
            </Link>
            <Link className="text-danger" to="#">
              <i
                className="bx bx-trash font-size-18 mt-1"
                id="edittooltip"
                onClick={() => this.handleOpenDeleteModal(user)}
              ></i>
            </Link>
          </div>
        ),
      },
    ];

    return (
      <React.Fragment>
        <DeleteModal
          show={deleteModal}
          onDeleteClick={this.handleDeleteUser}
          onCloseClick={() =>
            this.setState({ deleteModal: false, selectedUser: null })
          }
        />
        <div className="page-content">
          <MetaTags>
            <title>خانه من | مدیریت کاربران</title>
          </MetaTags>
          <Container fluid>
            <Breadcrumbs title="خانه من" breadcrumbItem="مدیریت کاربران" />
          </Container>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {loading ? (
                    <Spinner size="lg" />
                  ) : (
                    <PaginationProvider
                      pagination={paginationFactory(pageOptions)}
                      keyField="id"
                      columns={columns}
                      data={users}
                    >
                      {({ paginationProps, paginationTableProps }) => (
                        <ToolkitProvider
                          keyField="id"
                          columns={columns}
                          data={users}
                          search
                        >
                          {toolkitprops => (
                            <React.Fragment>
                              <Row className="mb-2">
                                <Col sm="4">
                                  <div className="search-box ms-2 mb-2 d-inline-block">
                                    <div className="position-relative">
                                      <SearchBar
                                        {...toolkitprops.searchProps}
                                        placeholder="جستجو"
                                      />
                                      <i className="bx bx-search-alt search-icon" />
                                    </div>
                                  </div>
                                </Col>
                                <Col sm="8">
                                  <div className="text-sm-end">
                                    <Button
                                      color="primary"
                                      className="font-16 btn-block btn btn-primary bg-gold"
                                      onClick={this.toggle}
                                    >
                                      <i className="mdi mdi-plus-circle-outline me-1" />
                                      ایجاد کاربر جدید
                                    </Button>
                                  </div>
                                </Col>
                              </Row>
                              <Row>
                                <Col xl="12">
                                  <div className="table-responsive">
                                    <BootstrapTable
                                      {...toolkitprops.baseProps}
                                      {...paginationTableProps}
                                      selectRow={selectRow}
                                      defaultSorted={defaultSorted}
                                      classes={
                                        "table align-middle table-nowrap table-hover"
                                      }
                                      bordered={false}
                                      striped={false}
                                      responsive
                                      ref={this.node}
                                    />

                                    <Modal
                                      isOpen={modal}
                                      onClosed={() =>
                                        this.setState({
                                          formValue: {
                                            name: "",
                                            mobile: "",
                                            type: "admin",
                                          },
                                        })
                                      }
                                    >
                                      <ModalHeader
                                        toggle={this.toggle}
                                        tag="h4"
                                      >
                                        {!!isEdit
                                          ? "ویرایش کاربر"
                                          : "اضافه کردن کاربر"}
                                      </ModalHeader>
                                      <ModalBody>
                                        <Formik
                                          enableReinitialize={true}
                                          initialValues={formValue}
                                          validationSchema={Yup.object().shape({
                                            name: Yup.string().required(
                                              "لطفا نام را وارد کنید"
                                            ),
                                            mobile: Yup.number().required(
                                              "لطفا شماره همراه را وارد کنید"
                                            ),
                                            type: Yup.string(),
                                          })}
                                          onSubmit={this.handleSubmitAddForm}
                                        >
                                          {({ errors, status, touched }) => (
                                            <Form>
                                              <Row>
                                                <Col className="col-12">
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      نام
                                                    </Label>
                                                    <Field
                                                      name="name"
                                                      type="text"
                                                      className={
                                                        "form-control" +
                                                        (errors.name &&
                                                        touched.name
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="name"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      شماره همراه
                                                    </Label>
                                                    <Field
                                                      name="mobile"
                                                      type="text"
                                                      className={
                                                        "form-control" +
                                                        (errors.mobile &&
                                                        touched.mobile
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    />
                                                    <ErrorMessage
                                                      name="mobile"
                                                      component="div"
                                                      className="invalid-feedback"
                                                    />
                                                  </div>
                                                  <div className="mb-3">
                                                    <Label className="form-label">
                                                      نوع کاربری
                                                    </Label>
                                                    <Field
                                                      name="type"
                                                      as="select"
                                                      className={
                                                        "form-control" +
                                                        (errors.type &&
                                                        touched.type
                                                          ? " is-invalid"
                                                          : "")
                                                      }
                                                    >
                                                      <option value="admin">
                                                        مدیر
                                                      </option>
                                                      <option value="user">
                                                        کاربر
                                                      </option>
                                                    </Field>
                                                  </div>
                                                </Col>
                                              </Row>
                                              <Row>
                                                <Col>
                                                  {subLoading ? (
                                                    <div className="text-end">
                                                      <button
                                                        type="button"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        <i className="bx bx-loader bx-spin font-size-16 align-middle" />{" "}
                                                        Loading
                                                      </button>
                                                    </div>
                                                  ) : (
                                                    <div className="text-end">
                                                      <button
                                                        type="submit"
                                                        className="btn btn-success save-user bg-gold"
                                                        style={{
                                                          minWidth: "100px",
                                                        }}
                                                      >
                                                        Save
                                                      </button>
                                                    </div>
                                                  )}
                                                </Col>
                                              </Row>
                                            </Form>
                                          )}
                                        </Formik>
                                      </ModalBody>
                                    </Modal>
                                  </div>
                                </Col>
                              </Row>
                              <Row className="align-items-md-center mt-30">
                                <Col className="pagination pagination-rounded justify-content-end mb-2">
                                  <PaginationListStandalone
                                    {...paginationProps}
                                  />
                                </Col>
                              </Row>
                            </React.Fragment>
                          )}
                        </ToolkitProvider>
                      )}
                    </PaginationProvider>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </React.Fragment>
    );
  }
}

export default Users;
